import { memo } from "react"
import { Outlet } from "@tanstack/react-router"

import { cn } from "@productlane/lib/src/cn"

import { spotlightAnchorRef } from "@/components/ai-widget-launcher"
import { CommandMenu } from "@/components/cmdk"
import { DetailDrawer } from "@/components/detail-drawer"
import { ErrorBoundary } from "@/components/error-boundary"
import { useFirstRunRevealTrigger } from "@/components/first-run-reveal"
import { OutOfOfficeDialog } from "@/components/out-of-office/out-of-office-dialog"
import { useLockDocumentScroll } from "@/lib/hooks/use-lock-document-scroll"
import { PresenceProvider } from "@/lib/use-presence"
import { ThreadLockProvider } from "@/lib/use-thread-lock"
import { useTrial } from "@/lib/useTrial"
import { useRememberAppPath } from "../settings/settings-return-path"
import { Paywall } from "./paywall"
import { Sidebar } from "./sidebar"

export const AppLayout = memo(() => {
	useFirstRunRevealTrigger()
	useRememberAppPath()
	useLockDocumentScroll()

	return (
		<ThreadLockProvider>
			<PresenceProvider>
				<Sidebar content={<Content />} />
			</PresenceProvider>
		</ThreadLockProvider>
	)
})

const Content = () => {
	const { hasTrialEnded } = useTrial()

	return (
		<div
			ref={spotlightAnchorRef}
			className={cn("flex h-full flex-1 flex-col overflow-hidden", {
				"max-h-dvh": hasTrialEnded,
			})}
		>
			<Paywall />
			<CommandMenu />
			<OutOfOfficeDialog />
			{!hasTrialEnded && (
				<>
					<ErrorBoundary boundary="main" resetOnNavigate>
						<Outlet />
					</ErrorBoundary>
					<ErrorBoundary boundary="drawer" resetOnNavigate>
						<DetailDrawer />
					</ErrorBoundary>
				</>
			)}
		</div>
	)
}
